import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import TamCalculatorCTA from '../../ctas/TamCalculator';
import ourDataSmall from '@icons/ourDataSmall';
import gdprComplianceSmall from '@icons/gdprComplianceSmall';
import informationSecuritySmall from '@icons/informationSecuritySmall';

import SuccessStoryCTA from '../../ctas/SuccessStory';

export const OurData = () => {
  const { t } = useTranslation();
  return {
    label: t('nav_our_data_page'),
    submenus: [
      {
        
        label: " ",
        columns: 3,
        subgroups: [
          {
            label: t('nav_our_data_page'),
            href: '/our-data',
            icon: ourDataSmall,
            caption: t('nav_our_data_label'),
            grid: true,
          },
          {
            label: t('nav_gdpr_page'),
            href: '/gdpr',
            caption: t('nav_gdpr_label'),
            icon: gdprComplianceSmall,
            grid: true,
          },
          {
            label: t('nav_information_security'),
            href: '/security',
            caption: t('nav_label_security_caption'),
            icon: informationSecuritySmall,
            grid: true,
          },
        ],
      },
    ],
    ctas: [
      { label: t('nav_free_tools'), content: <TamCalculatorCTA /> },
      { label: t('nav_latest_success_stories'), content: <SuccessStoryCTA /> },
    ],
  };
};
